export const sizes = `<span class="badge sm">badge</span>
<span class="badge md">badge</span>
<span class="badge lg">badge</span>
<span class="badge xl">badge</span>`

export const colors = `<span class="badge dark">badge</span>
<span class="badge success">badge</span>
<span class="badge primary">badge</span>
<span class="badge info">badge</span>
<span class="badge danger">badge</span>
<span class="badge warning">badge</span>

<span class="badge gradient dark">badge</span>
<span class="badge gradient success">badge</span>
<span class="badge gradient primary">badge</span>
<span class="badge gradient info">badge</span>
<span class="badge gradient danger">badge</span>
<span class="badge gradient warning">badge</span>`